import { compose, flatMap, groupBy, map, mapValues } from 'lodash/fp';
import { Companionship } from '@mews-commander/types';
import { getOrEmptyArray } from '@mews/fp';
import { Reservation } from '@mews-commander/data-access';

const groupCompanionIdsByReservation = compose(mapValues(map('companionId')), groupBy<Companionship>('reservationId'));

export const formatSpaceTableData = (companionships: Companionship[], reservations: Reservation[]) => {
    const groupedCompanionIds = groupCompanionIdsByReservation(companionships);

    return flatMap(({ id, assignedResourceId }) => {
        const [firstCompanionId, ...restCompanionIds] = getOrEmptyArray(id, groupedCompanionIds) as (
            | string
            | undefined
        )[];
        const customerIdObjects = map((companionId) => ({ customerId: companionId }), restCompanionIds);

        return [{ assignedResourceId, customerId: firstCompanionId }, ...customerIdObjects];
    }, reservations);
};
